import React, { useState, useRef, Fragment } from 'react';
import { observer } from 'mobx-react-lite';
import planQuestionStore from './store';
import { runInAction, toJS } from 'mobx';
import { SVGPureIcon } from '@/ui';
import { HelperCore } from '@/common/dependencies';
import { Dropdown } from 'antd';
import { useEffect } from 'react';
import { useMemo } from 'react';

const showAddTaskBtn = false;
const empty_tool_name = '--';
const dealToolName = (toolName, text) => {
  if (toolName) {
    return toolName;
  } else {
    const regex = /\[(.*?)\]/;
    const matches = text.match(regex);
    if (matches) {
      return matches[1];
    } else {
      return empty_tool_name;
    }
  }
};

//设置光标
const setCursorPosition = (div, position) => {
  const textNode = div.childNodes[0];
  if (!textNode) {
    return;
  }
  const range = document.createRange();
  const sel = window.getSelection();
  range.setStart(textNode, position);
  range.setEnd(textNode, position);

  sel.removeAllRanges(); // 清除现有选区
  sel.addRange(range); // 添加新的选区
};

const ModifyTips = ({ tips }) => {
  return (
    <div className="flex mt-4px">
      <div className="flex items-center px-4px py-6px bg-black bg-opacity-4 rounded-6px">
        <SVGPureIcon name="plan_thinking" className="size-12px mr-3px" />
        <span className="text-12px text-black text-opacity-50">{tips}</span>
      </div>
    </div>
  );
};

const TextList = observer(
  ({
    items,
    item,
    index,
    subIndex = 0,
    parentIndex,
    disable,
    planStepId,
    itemType,
    event,
  }) => {
    const [canEdit, setCanEdit] = useState(false);
    const [isFocus, setIsFocus] = useState(false);
    const [showDropdown, setShowDropdown] = useState(false);
    const editDivRef = useRef(null);
    const isLast = index == items.length - 1;
    const editted = ['add', 'edit'].includes(item.status);
    const deleted = ['del'].includes(item.status);
    const menus = (item.available_tools || []).map(item => {
      item.key = item.tool_name;
      item.label = item.tool_name_cn;
      return item;
    });
    const dealedToolName = dealToolName(item.tool_name_cn, item.text);
    const dropdownForbid = dealedToolName == empty_tool_name || menus.length <= 1;

    useEffect(() => {
      if (disable) {
        setShowDropdown(false);
      }
    }, [disable]);

    return (
      <Fragment key={index}>
        <div
          key={index}
          className={[
            'flex text-black text-14px border-b-1px border-black border-opacity-10',
            isLast ? '!border-b-0' : '',
          ]}
        >
          <div style={{ height: 'inherit' }} className="w-48px vh-center ">
            {index + 1}.{subIndex}
          </div>
          <Dropdown
            menu={{
              items: menus,
              selectable: true,
              defaultSelectedKeys: [item.tool_name],
              onClick: evt => {
                const checkItem = item.available_tools.find(
                  item => item.tool_name == evt.key
                );
                const resItem = items.map(_item => {
                  runInAction(() => {
                    if (item.id == _item.id) {
                      _item.tool_name = checkItem.tool_name;
                      _item.tool_name_cn = checkItem.tool_name_cn;
                    }
                  });
                  return _item;
                });
                planQuestionStore.updatePlanData(
                  planStepId,
                  itemType,
                  parentIndex,
                  'items',
                  resItem
                );
              },
            }}
            trigger="click"
            open={showDropdown}
            placement="bottomLeft"
            disabled={disable || dropdownForbid}
            //disabled={false}
            overlayClassName="text-list-dropdown"
            onOpenChange={visible => {
              setShowDropdown(visible);
            }}
          >
            <div
              style={{ height: 'inherit' }}
              className={[
                'relative w-130px py-10px px-8px leading-20px flex items-center border-r-1px border-l-1px border-black border-opacity-10',
                disable ? '' : 'cursor-pointer',
                showDropdown ? 'plan-div-edit' : '',
              ]}
            >
              <SVGPureIcon
                name="plan_tool"
                className="size-16px mr-4px flex-shrink-0"
              />
              {dealedToolName}
              <div className="pl-4px ml-auto">
                <SVGPureIcon
                  name="task_dropdown_arrow"
                  className={[
                    'size-10px flex-shrink-0 transform transition-all',
                    showDropdown ? 'rotate-[180deg]' : '',
                    disable ? 'opacity-50' : '',
                    dropdownForbid ? 'hidden' : '',
                  ]}
                />
              </div>
            </div>
          </Dropdown>
          <div
            className={[
              'flex flex-col justify-center px-12px py-9px flex-grow w-0 relative',
              canEdit ? 'plan-div-edit' : '',
            ]}
          >
            <div
              ref={editDivRef}
              suppressContentEditableWarning
              contentEditable={canEdit}
              onInput={evt => {
                evt.stopPropagation();
                const maxLength = 100;
                const div = evt.target;
                if (div.innerText.length > maxLength) {
                  div.innerText = div.innerText.slice(0, maxLength);
                  setCursorPosition(div, maxLength);
                }
              }}
              maxLength={10}
              onBlur={evt => {
                evt.stopPropagation();
                setTimeout(() => {
                  setCanEdit(false);
                  setIsFocus(false);
                }, 200);
                if (!editDivRef.current?.innerText?.trim()) {
                  //为空时做删除处理
                  const resItem = items.filter(_item => item.id != _item.id);
                  planQuestionStore.updatePlanData(
                    planStepId,
                    itemType,
                    parentIndex,
                    'items',
                    resItem
                  );
                  return;
                }
                const resItem = items.map(_item => {
                  runInAction(() => {
                    if (item.id == _item.id) {
                      _item.text = editDivRef.current.innerText;
                    }
                  });
                  return _item;
                });
                planQuestionStore.updatePlanData(
                  planStepId,
                  itemType,
                  parentIndex,
                  'items',
                  resItem
                );
              }}
              onFocus={evt => {
                evt.stopPropagation();
                setIsFocus(true);
              }}
              onClick={evt => {
                if (event.status == 'running') {
                  evt.stopPropagation();
                }
              }}
              className={[
                'relative w-full leading-20px break-all border-1px border-transparent pr-74px',
              ]}
            >
              {editted || deleted ? (
                <span
                  className={[
                    'px-10px py-4px rounded-6px',
                    'leading-20px break-all inline-block',
                    {
                      'bg-[#FF7307] bg-opacity-20': editted,
                    },
                    {
                      'line-through text-[rgba(0,0,0,0.5)]': deleted,
                    },
                  ]}
                >
                  {item.text}
                </span>
              ) : (
                item.text
              )}
            </div>
            {editted || deleted ? (
              <ModifyTips tips={item.tips || '由模型反思后增加'} />
            ) : null}
            <div
              className={[
                'absolute right-12px top-1/2 transform -translate-y-1/2',
                'flex items-center mcp-mobile-hidden',
                isFocus || disable ? 'invisible' : '',
                canEdit ? 'invisible' : '',
              ]}
            >
              <div
                onClick={evt => {
                  evt.stopPropagation();
                  setCanEdit(true);
                  setTimeout(() => {
                    editDivRef.current?.focus();
                    setCursorPosition(editDivRef.current, item.text.length);
                  }, 20);
                }}
                className="size-28px vh-center bg-black bg-opacity-0 hover:bg-opacity-3 rounded-6px js-modify-btn"
              >
                <SVGPureIcon
                  name="plan_modify"
                  className="size-20px cursor-pointer"
                />
              </div>
              <div
                onClick={evt => {
                  evt.stopPropagation();
                  const resItem = items.filter(_item => item.id != _item.id);
                  planQuestionStore.updatePlanData(
                    planStepId,
                    itemType,
                    parentIndex,
                    'items',
                    resItem
                  );
                }}
                className="size-28px vh-center bg-black bg-opacity-0 hover:bg-opacity-3 rounded-6px"
              >
                <SVGPureIcon
                  name="plan_delete"
                  className="size-20px cursor-pointer"
                />
              </div>
            </div>
          </div>
        </div>
        {isLast && !disable && showAddTaskBtn ? (
          <div className="h-68px w-full py-16px px-12px vh-center border-t-1px border-black border-opacity-10">
            <div
              onClick={evt => {
                const emptyItem = HelperCore.copyObj(items[0]);
                emptyItem.tool_name = '';
                emptyItem.tool_name_cn = '';
                emptyItem.text = '';
                emptyItem.id = +new Date();
                runInAction(() => {
                  items.push(emptyItem);
                });
                const wrap = evt.target.closest('.js-table-wrap');
                setTimeout(() => {
                  const btns = wrap.querySelectorAll('.js-modify-btn');
                  btns[btns.length - 1].click();
                }, 20);
                evt.stopPropagation();
              }}
              className="vh-center bg-[#F7F7F7] hover:bg-[#eee] rounded-8px cursor-pointer border-1px border-black border-opacity-16 border-dashed w-full h-full"
            >
              <SVGPureIcon name="task-add" className="size-16px mr-6px" />
              <span className="text-14px text-black font-bold">添加新任务</span>
            </div>
          </div>
        ) : null}
      </Fragment>
    );
  }
);
export default TextList;
